module.exports = __webpack_public_path__ + "static/media/25pic.5301533e.jpg";